import { useNavigate, useParams } from 'react-router-dom';

import { DocumentDetailModal } from './DocumentDetailModal';

/**
 * Full-screen route for viewing a document_reference — the document analog of
 * `/note/:noteId`. Migrated clinical notes (stored as `clinical_note` docrefs)
 * open here. Reuses DocumentDetailModal's PDF viewer; closing returns to the
 * previous page.
 */
export function DocumentRoute() {
  const { documentId } = useParams<{ documentId: string }>();
  const navigate = useNavigate();

  return (
    <DocumentDetailModal
      open
      documentId={documentId ?? null}
      onClose={() => navigate(-1)}
    />
  );
}
